import { convertEnumToString } from '@/utils/index'

import { DefectLike } from 'types/vagueTypes'

export const getDefectName = (defect: DefectLike): [string, string] => {
  if (!defect) return ['', '']

  const type = convertEnumToString(defect.type, false)
  const title = defect.title || `${type} #${defect.order}`

  return [title, type]
}
